import {
  CUSTOM_FUNCTION_VALIDATE,
  CUSTOM_FUNCTION_SAVE,
  CUSTOM_FUNCTION_LIST,
  CUSTOM_FUNCTION_GET,
  CUSTOM_FUNCTION_UPDATE,
  CUSTOM_FUNCTION_DELETE,
} from "../types";

export const customFunctionValidateAction = (data, onSuccess, onError) => {
  return {
    type: CUSTOM_FUNCTION_VALIDATE,
    data,
    onSuccess,
    onError,
  };
};

export const customFunctionSaveAction = (data, onSuccess, onError) => {
  return {
    type: CUSTOM_FUNCTION_SAVE,
    data,
    onSuccess,
    onError,
  };
};

export const customFunctionListAction = (onSuccess, onError) => {
  return {
    type: CUSTOM_FUNCTION_LIST,
    onSuccess,
    onError,
  };
};

export const customFunctionGetAction = (data, onSuccess, onError) => {
  return {
    type: CUSTOM_FUNCTION_GET,
    data,
    onSuccess,
    onError,
  };
};

export const customFunctionUpdateAction = (data, onSuccess, onError) => {
  return {
    type: CUSTOM_FUNCTION_UPDATE,
    data,
    onSuccess,
    onError,
  };
};

export const customFunctionDeleteAction = (data, onSuccess, onError) => {
  return {
    type: CUSTOM_FUNCTION_DELETE,
    data,
    onSuccess,
    onError,
  };
};
